module.exports = __webpack_public_path__ + "media/images/marketing-banner/arrow-6f5d28eb3ad3133aa7452afaadbcdf09.svg";